import InputType from "@/services/Input/InputType.js";

// see details: "@/services/Input/DataCatalog.js"
export default {
  Search: {
    Label: "Cari Nomor Pengiriman, Nomor Kendaraan atau Tujuan",
    Type: InputType.Text,
    MaxLength: 50
  },
  WarehouseID: {
    Label: "Gudang",
    Type: InputType.ID,
    Input: InputType.Select
  },
  StatusID: {
    Label: "Status",
    Type: InputType.Select
  },
  Date: {
    Label: "Tanggal",
    Type: InputType.Date,
    IsRange: true,
    Required: true,
    RequiredHide: true
  }
}